import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";
import Search from "./Search";
import { QueryClientProvider, QueryClient } from "react-query";

import { theme } from "../../assets/style/theme";
import GrobalStyle from "../../assets/style/global-style";
import Nav from "./Nav";
import { SiteHeaderSection } from "./style";
import { GnbSection } from "./Nav/style";
import SubNav from "./SubNav";
import { useMediaQuery } from "@chakra-ui/react";

import logo from "../../assets/images/logo.png";
import logo_w from "../../assets/images/logo_w.png";
import logo_en from "../../assets/images/logo_en.jpg";
import lang from "../../assets/images/icons/language.svg";
import menu from "../../assets/images/icons/menu.svg";
import close_w from "../../assets/images/icons/close_w.svg";
import User from "./User";

declare global {
  interface Window {
    __LANG__: 'en' | 'ko';
  }
}

const queryClient = new QueryClient();

declare var __AUTH__: any;

const testUserInfo:any = {
  isLoggedIn: true,
  user: {
    ID: '1789',
    display_name: 'bobadmin',
    user_email: 'bob@heem.net'
  }
}

const defaultUserInfo:any = {
  isLoggedIn: false,
  user: {
    ID: '-1',
    display_name: '',
    user_email: ''
  }
}

function SiteHeader() {
  const [hover, setHover] = useState(0);
  const [scrollDirection] = useState("down");
  const [mobileNavActive, setMobileNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(defaultUserInfo);

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const [gnbSlug, setGnbSlug] = useState<string|null>(null);

  const hoverMenu = (id: any) => {
    setHover(id);
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setUserInfo(testUserInfo);
    } else {
      setUserInfo(__AUTH__ ? __AUTH__ : defaultUserInfo);
    }

    setGnbSlug(window.__LANG__ === 'en' ? 'gnb-en' : 'gnb');
  }, []);

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
      <ThemeProvider theme={theme}>
        <GrobalStyle />
        <QueryClientProvider client={queryClient}>
          <SiteHeaderSection direction={scrollDirection}>
            <section>
              <h1 className="logo">
                <a href={ isEnglish ? '/en' : '/' }>
                  <img src={isEnglish ? logo_en :  logo} alt="재단법인 숲과나눔" width={isMobile ? '134' : '216'} />
                </a>
              </h1>

              {
                (!isMobile || (isMobile && mobileNavActive)) && (
                  <GnbSection>
                    {
                      isMobile && (
                        <>
                        <div className="mobile-header">
                          <h1 className="mobile-logo">
                            <a href="/">
                              <img src={logo_w} alt="재단법인 숲과나눔" width="134" />
                            </a>
                          </h1>
                          <div className="mobile-prn">
                            {/* <Search /> */}
                            <button onClick={() => setMobileNavActive(false)}>
                              <img src={close_w} width="16" alt="메뉴 닫기" />
                            </button>
                          </div>
                        </div>     
                        <User userInfo={userInfo} />
                        </>
                      )
                    }
                    {
                      gnbSlug && (
                        <Nav
                          slug={gnbSlug}
                          direction={scrollDirection}
                          onHover={hoverMenu}
                          isMobile={isMobile}
                        />
                      )
                    }
                  </GnbSection>
                )
              }

              {
                !isMobile && (
                  <User userInfo={userInfo} />
                )
              }

              <div className="prn">
                {
                  (!isMobile && !isEnglish) && (
                    <Search />
                  )
                }
                <a href={isEnglish ? '/' : '/en'} >
                  <img src={lang} alt={isEnglish ? "Korean" : "English"} width="32" />
                </a>
                {
                  isMobile && (
                    <button onClick={() => setMobileNavActive(true)}>
                      <img src={menu} width="24" alt="메뉴 열기" />
                    </button>
                  )
                }
              </div>
            </section>
            {
            !isMobile && (<SubNav onHover={hoverMenu} hoveredItemId={hover} />)}            
          </SiteHeaderSection>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
}

SiteHeader.defaultProps = {};

export default SiteHeader;
